<template>
  <input
    @focus="hidePlaceHolder"
    @blur="showPlaceHolder"
    v-model="text"
    class="input-widget"
    :placeholder="placeholderData"
    :type="isPassword ? 'password' : 'text'"
    :disabled="disabled"
    :class="isBorder == 1 ? 'input-red-outline' : isBorder == 2 ? 'input-yellow-outline': null"
  />
</template>

<script>
export default {
  name: "InputWidget",
  props: {
    placeholder: String,
    isPassword: Boolean,
    disabled: Boolean,
    isBorder: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      text: "",
      placeholderData: "",
    };
  },

  mounted() {
    this.placeholderData = this.placeholder;
  },

  watch: {
    text: function (val) {
      this.$emit("changed", val);
    },
  },
  methods: {
    hidePlaceHolder() {
      this.placeholderData = "";
    },
    showPlaceHolder() {
      this.placeholderData = this.placeholder;
    },
  },
};
</script>

<style scoped>
input {
  width: 297px;
  border: none;
  border-radius: 10px;
  background-color: #131517;
  height: 50px;
  padding: 0px 16px;
  color: #fff;
  margin: auto;
  margin-bottom: 16px;
  box-shadow: 0px 2px 4px #000000;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
}

.input-red-outline{
  border: 2px solid #d83c0c;

}

.input-yellow-outline{
  border: 2px solid #eddb51;

}

input:focus {
  outline: none;
}
</style>